/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Divider, Button, CircularProgress } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import { v4 as uuidv4 } from 'uuid';

import Actions from '../../../../fluid/Actions/ActionFactory'
import Link from './components/Link'

const clone = require("rfdc")();

let links_temp = {
    type: "screen",
    name: null,
    route: null,
    config: "/src/configs/screens/screens/queue-config.js",
    roles: ["ROLE_L1", "ROLE_ADMIN"],
    show_in_sidebar : true,
    default_params : {
        showAppbar : true,
        url : "",
        unsafe_http : false,
        is_standalone : false,
        query_params : []
    },
    component : "link"
}


const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class Links extends Component {
    state = {
        loading : false,
        linked_screens : []
    }

    componentDidMount () {
        this.getLinkedScreens()
    }

    getLinkedScreens = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
        let link_section = routes.drawer.find(section => section.id === 'links')
        let linked_screens = link_section.screens.filter(link => link.component === 'link')
        this.setState({...this.state, linked_screens: linked_screens}, () => console.log("Search Screens : ", this.state.search_screens))
    }

    updateLink = (link_config) => {
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
        }).then(res => {
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let routes = res.data.result.config
            let link_section = routes.drawer.find(section => section.id === 'links')
            let linked_screens = link_section.screens.filter(link => link.component === 'link')

            let link_index = linked_screens.findIndex(link => link.id === link_config.id)
            if (link_index !== -1) {
                console.log("Updating Linked Screen: ", link_config)
                linked_screens.splice(link_index, 1, link_config)
            } else {
                console.log("Adding Search Screen: ", link_config)
                linked_screens.push(link_config)
            }
            this.setState({...this.state, linked_screens: linked_screens}, () => sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config)))
            this.updateLinkedScreens(linked_screens)
        })
    }

    updateLinkedScreens = (linked_screens) => {
        console.log("Updating Search Screens with : ", linked_screens)
        // Actions('http_request', {
        //     url : "/sainapse/configuration/ui_routes",
        //     method : "get",
        //     data : {}
        // }).then(res => {
        //     let routes = res.data.result.config
            let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let link_section = routes.drawer.find(section => section.id === 'links')
            link_section.screens = [...linked_screens]
            console.log("Adding Linked Screens to Routes : ", link_section)
            console.log("Updating Routes : ", routes)
            
            Actions('http_request', {
                url : "/sainapse/configuration/ui_routes",
                method : "put",
                data : {
                    config : routes
                }
            }).then(res => {
                let routes = res.data.result.config
                let link_section = routes.drawer.find(section => section.id === 'links')
                let linked_screens = link_section.screens.filter(link => link.component === 'link')
                this.setState({...this.state, linked_screens: linked_screens, editing_id : null}, () => sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config)))
            })
        //})
    }

    deleteLink = (config) => {
        let new_state = clone(this.state)
        let link_index = new_state.linked_screens.findIndex(link => link.id === config.id)
        new_state.linked_screens.splice(link_index, 1)
        this.updateLinkedScreens(new_state.linked_screens)
    }

    editLink = (config) => {
        this.setState({...this.state, editing_id : config.id})
    }

    renderLinkedScreens = () => {
        if (this.state.loading) {
            return (
                <div style = {{width : '100%', marginTop : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                    <CircularProgress variant = 'indeterminate'/>
                </div>
            )
        } else {
            let linked_screens = this.state.linked_screens.map(linked_screen => {
                return (
                    <Link
                        config = {linked_screen}
                        update = {(config) => this.updateLink(config)}
                        delete = {(config) => this.deleteLink(config)}
                        enable_edit = {(config) => this.editLink(config)}
                        editing_id = {this.state.editing_id}
                    />
                )
            })

            return linked_screens
        }
    }

    addScreen = () => {
        let new_screen = clone(links_temp)
        new_screen.id = uuidv4()
        let new_state = clone(this.state)
        new_state.linked_screens.push(new_screen)
        new_state.editing_id = new_screen.id
        this.setState({...new_state})
    }

    renderAddScreen = () => {
        return (
            <Button
                style = {{marginTop : '10px'}}
                variant = 'contained'
                size = 'small'
                color = 'primary'
                startIcon = {<Add/>}
                onClick = {this.addScreen}
            >
                Add Screen
            </Button>
        )
    }

    renderContent = () => {
        if (this.state.loading_ics) {
            return (
                <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant = 'indeterminate' color = 'primary'/>
                </div>
            )
        } else {
            return (
                <Fragment>
                    {this.renderLinkedScreens()}
                    {this.renderAddScreen()}
                </Fragment>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', maxHeight : '100%', overflow : 'auto', padding : '10px'}}>
                    <Typography variant = 'subtitle2'>Linked Screens</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderContent()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Links);